// extracted by mini-css-extract-plugin
module.exports = {"photo":"answerer_photo__2BoxX","pill":"answerer_pill__3yamk"};